<template>
  <v-layout row wrap pa-3>
    <v-flex xs12>
      <v-layout row wrap main-section>
        <v-flex xs12 pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
              {{ $store.getters.getHeadingForBalanceBlock }}
            </h3> -->
            <v-icon>mdi-office-building</v-icon>
            <h4 class="headline halfwhite-text ml-2">Manage Organization</h4>
          </v-card-title>
          <v-flex xs12 style="margin-top: -50px">
            <v-tabs
              right
              color="transparent"
              slider-color="transparent"
              no-animation
              active-class="tab-active"
              class="rounded-tl rounded-tr"
            >
              <v-tab class="hidden-sm-and-down">
                <div class="d-flex align-center">
                  <span class="mdi mdi-information mdi-18px"></span>
                  <span class="ml-1">Details</span>
                </div>
              </v-tab>
              <v-tab class="hidden-sm-and-down">
                <div class="d-flex align-center">
                  <span class="mdi mdi-coin mdi-18px"></span>
                  <span class="ml-1">Transactions</span>
                </div>
              </v-tab>
              <v-tab class="hidden-sm-and-down">
                <div class="d-flex align-center">
                  <span class="mdi mdi-settings mdi-18px"></span>
                  <span class="ml-1">Settings</span>
                </div>
              </v-tab>
              <v-tab-item :lazy="true" :transition="false">
                <v-card flat color="transparent" class="rounded-bl rounded-br">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        md6
                        mb-2
                        pr-2
                        v-if="
                          ($store.getters.userIsAdministrativeOrOrgOwner ||
                            $store.getters.isHRManager) &&
                          $store.getters.isCurrentOrgSet
                        "
                      >
                        <OrganizationDetails></OrganizationDetails>
                      </v-flex>
                      <v-flex xs12 md6 mb-2 pr-2 v-else>
                        <v-card class="rounded">
                          <v-card-text>
                            <v-alert
                              :value="true"
                              outline
                              type="warning"
                              icon="warning"
                            >
                              Sorry! Either you do not have permission to view
                              Or you don't have any active org in your user
                              profile Or you are in a sub-org.
                            </v-alert>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-flex
                          mb-2
                          v-if="$store.getters.userIsAdministrativeOrOrgOwner"
                        >
                          <OrganizationCreate></OrganizationCreate>
                        </v-flex>
                        <v-flex>
                          <OrganizationsList></OrganizationsList>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :lazy="true" :transition="false">
                <v-card flat color="transparent" class="rounded-bl rounded-br">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex
                        v-if="
                          ($store.getters.userIsAdministrativeOrOrgOwner ||
                            $store.getters.isHRManager) &&
                          $store.getters.isCurrentOrgSet &&
                          !$store.getters.isCurrentOrgChild
                        "
                      >
                        <v-layout row wrap>
                          <v-flex xs12 md6 mb-2 pr-2>
                            <OvationTransactionHistory></OvationTransactionHistory>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-flex mb-2>
                              <StoreTransactions></StoreTransactions>
                            </v-flex>
                            <v-flex>
                              <Invoices></Invoices>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex v-else>
                        <v-card class="rounded elevation-0">
                          <v-card-text>
                            <v-alert
                              :value="true"
                              outline
                              type="warning"
                              icon="warning"
                              >Sorry! Either you do not have permission to view
                              Or you don't have any active org in your user
                              profile Or you are in a sub-org.</v-alert
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :lazy="true" :transition="false">
                <v-card flat color="transparent" class="rounded-bl rounded-br">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex
                        v-if="
                          ($store.getters.isSuperAdmin ||
                            $store.getters.isOrgAdmin) &&
                          $store.getters.isCurrentOrgSet &&
                          !$store.getters.isCurrentOrgChild
                        "
                      >
                        <v-layout row wrap>
                          <v-flex xs12 md6 mb-2 pr-2>
                            <AutoOvationAssignment></AutoOvationAssignment>
                          </v-flex>
                          <v-flex xs12 md6>
                            <OrgSettings></OrgSettings>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex v-else>
                        <v-card class="rounded elevation-0">
                          <v-card-text>
                            <v-alert
                              :value="true"
                              outline
                              type="warning"
                              icon="warning"
                              >Sorry! Either you do not have permission to view
                              Or you don't have any active org in your user
                              profile Or you are in a sub-org.</v-alert
                            >
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import OrganizationDetails from "@/components/OrganizationDetails";
import OrganizationCreate from "@/components/OrganizationCreate";
import OrganizationsList from "@/components/OrganizationsList";
import AutoOvationAssignment from "@/components/AutoOvationAssignment";
import OvationTransactionHistory from "@/components/OvationTransactionHistory";
import StoreTransactions from "@/components/StoreTransactions";
import OrgSettings from "@/components/OrgSettings";
import Invoices from "@/components/Invoices";

export default {
  name: "OrganizationView",
  components: {
    OrganizationDetails,
    OrganizationCreate,
    OrganizationsList,
    AutoOvationAssignment,
    OvationTransactionHistory,
    StoreTransactions,
    OrgSettings,
    Invoices,
  },
};
</script>

<style scoped>
.v-tabs__container .v-tabs__container--right {
  margin-right: 20px !important;
}
</style>